module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_footer_image_04-b867e8bc5053dfe9e1904a4404ae341b.jpg";